var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.breadcrumbs.length > 0)?_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }